import type { CategoryTile, NavLink } from "../types/vtc";

/**
 * Static home page data (nav, search areas, category tiles). Vehicles come
 * from the API (lib/marketplaceApi); visible text lives in src/i18n.
 */

export const NAV_LINKS: NavLink[] = [
  { key: "vehicles", href: "/vehicles" },
  { key: "howItWorks", href: "/how-it-works" },
  { key: "forCompanies", href: "/partners" },
  { key: "pricing", href: "/pricing" },
  { key: "blog", href: "/blog" },
];

/**
 * "Every location" in the search (shown as t.common.allAreas): no city filter.
 * The cities themselves come from the listings (GET /listings/cities).
 */
export const ALL_AREAS = "";

/** Search links made before ALL_AREAS was "" still open on every location. */
export const LEGACY_ALL_AREAS = ["All", "all"];

export const CATEGORY_TILES: CategoryTile[] = [
  { id: "electric", filter: "Electric" },
  { id: "hybrid", filter: "Hybrid" },
  { id: "premium", filter: "Premium sedan" },
  { id: "estate", filter: "Estate" },
];
